import React from 'react'

const HomePage = () => {
  return <div/>
}

export default HomePage
